/**
 * Constantes unificadas de coordenação distribuída (leader + flush lock).
 */

export const FLUSH_LOCK_TTL_MS = 15_000;
export const LEADER_TTL_MS = 8_000;
export const LEADER_HEARTBEAT_MS = 3_000;
export const LEADER_STALE_MS = 8_000;
export const LEADER_GRACE_MS = 2_000;
export const FLUSH_LOCK_HEARTBEAT_MS = 4_000;
export const TAB_REGISTRY_STALE_MS = 12_000;
export const TAB_ALIVE_BROADCAST_MS = 4_000;
